import type { GuideConfig } from './types';

export const hanbokGuide: GuideConfig = {
  categoryKey: 'hanbok',
  title: '신부님의 한복 기준을 정리해드릴게요',
  subtitle: '현직 플래너의 질문을 바탕으로\n나에게 맞는 한복 선택 기준을 확인해보세요.',
  plannerIntro: '플래너 기준 기반',
  questionCount: 5,
  estimatedTime: '약 60초',

  questions: [
    {
      id: 'h1',
      category: '용도',
      questionText: '한복은 어떤 용도로 준비하시나요?',
      helperText: '본식, 폐백, 혼주 한복 등 필요한 범위를 기준으로 선택해주세요.',
      selectionType: 'single',
      options: [
        { id: 'h1-wedding-only', label: '본식 당일에만', description: '신랑신부 한복만 필요해요', resultType: 'practical', reaction: '본식 당일만 착용하신다면 대여로도 충분히 아름다운 한복을 입으실 수 있어요. 합리적인 선택이에요.' },
        { id: 'h1-both', label: '본식 + 폐백', description: '두 가지 용도로 준비', resultType: 'classic', reaction: '본식과 폐백 모두 한복을 입으신다면 맞춤이나 반맞춤을 고려해볼 만해요. 용도에 따라 디자인을 달리할 수도 있어요.' },
        { id: 'h1-family', label: '혼주 한복까지 함께', description: '양가 부모님 한복도 같이', resultType: 'traditional', reaction: '혼주 한복까지 함께 준비하시면 패키지로 더 좋은 조건을 받을 수 있어요. 가족 모두의 품격을 챙기는 선택이에요.' },
        { id: 'h1-heirloom', label: '맞춤 제작으로 평생 소장', description: '고급 원단으로 제작', resultType: 'luxury', reaction: '맞춤 제작 한복은 평생 소장할 수 있는 예술 작품이에요. 내 몸에 딱 맞는 한복의 아름다움은 대여와는 차원이 다릅니다.' },
      ],
      tipText: '한복은 착용 횟수와 용도에 따라 대여·반맞춤·맞춤 중 결정하는 게 좋아요. 사진에서의 느낌과 실제 착용감이 다를 수 있으니 꼭 입어보고 결정하세요.',
    },
    {
      id: 'h2',
      category: '색감',
      questionText: '한복 색감은 어떤 스타일을 선호하시나요?',
      helperText: '결혼식 시즌과 장소의 분위기를 함께 고려해보세요.',
      selectionType: 'single',
      options: [
        { id: 'h2-traditional', label: '전통적이고 고급스러운', description: '궁중 스타일의 깊은 색감', resultType: 'traditional', reaction: '전통적인 궁중 컬러는 격식 있는 웨딩에 완벽하게 어울려요. 깊은 자주, 고급스러운 남색이 대표적이에요.' },
        { id: 'h2-pastel', label: '화사하고 밝은 파스텔', description: '봄·여름 웨딩에 어울리는', resultType: 'modern', reaction: '파스텔 톤 한복은 사진이 정말 예쁘게 나와요. 특히 야외 웨딩이나 하우스 웨딩에서 빛을 발해요.' },
        { id: 'h2-classic', label: '클래식하고 무난한', description: '누구에게나 잘 어울리는', resultType: 'classic', reaction: '클래식한 컬러 선택은 가장 안전한 선택이에요. 연지, 분홍, 아이보리 계열이 대표적이에요.' },
        { id: 'h2-unique', label: '개성 있는 모던 컬러', description: '트렌디한 배색과 포인트', resultType: 'modern', reaction: '모던한 컬러 배색은 일반적인 한복과는 다른 특별한 느낌을 줘요. 개성 있는 신부님께 추천드려요.' },
      ],
      tipText: '한복 색감은 결혼식 시즌과 장소, 그리고 본인의 피부톤을 함께 고려하는 게 중요해요. 사진 촬영 시 자연광 아래에서 더 예쁘게 나올 색을 고르세요.',
    },
    {
      id: 'h3',
      category: '방식',
      questionText: '한복은 대여와 맞춤 중 어떤 방식을 선호하시나요?',
      helperText: '착용 횟수와 보관 계획을 기준으로 선택해주세요.',
      selectionType: 'single',
      options: [
        { id: 'h3-rental', label: '대여로 충분해요', description: '합리적인 가격과 간편함', resultType: 'practical', reaction: '대여 한복도 요즘은 퀄리티가 정말 좋아졌어요. 보관 걱정도 없고 가격 부담도 적어서 많은 신부님들이 선택하는 방식이에요.' },
        { id: 'h3-semi', label: '반맞춤 대여', description: '기본 틀에 일부 맞춤', resultType: 'classic', reaction: '반맞춤은 기성 한복의 가격대로 체형에 맞는 편안함을 느낄 수 있어요. 대여와 맞춤의 중간 지점이에요.' },
        { id: 'h3-custom', label: '맞춤 제작', description: '내 몸에 딱 맞게', resultType: 'traditional', reaction: '맞춤 제작 한복은 착용감과 핏이 완전히 달라요. 특히 상체나 하체가 표준 체형이 아닌 분들께 추천드려요.' },
        { id: 'h3-luxury', label: '고급 원단 풀 맞춤', description: '장인의 손길로 완성', resultType: 'luxury', reaction: '고급 원단으로 제작한 맞춤 한복은 평생 간직할 예술품이에요. 자녀에게 물려줄 수도 있는 소중한 자산이 됩니다.' },
      ],
      tipText: '대여 한복은 결혼식 2~3개월 전에 예약하는 게 안전해요. 인기 있는 디자인은 시즌 전에 예약이 마감될 수 있어요. 맞춤은 최소 4~6주 전에 시작하세요.',
    },
    {
      id: 'h4',
      category: '디자인',
      questionText: '한복 디자인에서 가장 중요하게 생각하는 것은 무엇인가요?',
      helperText: '여러 개 선택할 수 있어요. 본인의 우선순위에 맞게 골라주세요.',
      selectionType: 'multi',
      options: [
        { id: 'h4-traditional', label: '전통미와 격식', description: '정통 한복의 아름다움', resultType: 'traditional', reaction: '전통미를 살린 한복은 시간이 지나도 변하지 않는 아름다움이 있어요. 격식 있는 예식에 완벽하게 어울려요.' },
        { id: 'h4-silhouette', label: '실루엣과 핏', description: '체형 보정과 라인', resultType: 'classic', reaction: '잘 맞는 한복은 착용했을 때 자신감이 달라져요. 특히 저고리 길이와 치마 풍성함이 핵심이에요.' },
        { id: 'h4-fabric', label: '원단의 퀄리티', description: '촉감과 광택', resultType: 'luxury', reaction: '좋은 원단은 사진에서도 확실히 달라 보여요. 은은한 광택이 얼굴을 화사하게 만들어줘요.' },
        { id: 'h4-modern', label: '현대적 감각', description: '퓨전 스타일과 개성', resultType: 'modern', reaction: '현대적인 감각을 가미한 퓨전 한복은 독특하면서도 아름다운 분위기를 연출해요.' },
        { id: 'h4-detail', label: '자수와 디테일', description: '세밀한 장식과 포인트', resultType: 'luxury', reaction: '정교한 자수와 디테일은 한복의 품격을 한 단계 높여줘요. 가까이서 봤을 때의 감동이 다릅니다.' },
      ],
      tipText: '한복은 전체적인 실루엣이 가장 중요해요. 저고리 길이, 치마 너비, 소매 라인이 본인의 체형과 조화를 이루는지 꼭 확인하세요.',
    },
    {
      id: 'h5',
      category: '예산',
      questionText: '한복 준비 예산은 어느 정도로 생각하고 계신가요?',
      helperText: '신랑신부 기준이며, 혼주 한복 포함 시 비용이 추가될 수 있어요.',
      selectionType: 'single',
      options: [
        { id: 'h5-under-300k', label: '30만원 미만', description: '대여 기본 구성', resultType: 'practical', reaction: '합리적인 예산으로도 아름다운 한복을 입으실 수 있어요. 대여 한복의 퀄리티가 예전보다 훨씬 좋아졌어요.' },
        { id: 'h5-300k-700k', label: '30~70만원', description: '반맞춤 대여 또는 기본 맞춤', resultType: 'classic', reaction: '반맞춤이나 기본 맞춤을 고려할 수 있는 예산이에요. 체형에 맞는 편안한 착용감을 경험하실 수 있어요.' },
        { id: 'h5-700k-1.5m', label: '70~150만원', description: '프리미엄 맞춤', resultType: 'traditional', reaction: '좋은 원단과 정교한 맞춤으로 완성도를 높일 수 있는 예산이에요. 원단 선택의 폭도 넓어져요.' },
        { id: 'h5-over-1.5m', label: '150만원 이상', description: '최고급 맞춤 + 혼주 포함', resultType: 'luxury', reaction: '최고급 원단과 장인의 핸드메이드로 완성하는 프리미엄 한복을 경험하실 수 있어요. 평생 소장할 가치가 있는 투자예요.' },
      ],
      tipText: '한복 예산에는 대여·맞춤비 외에도 속옷, 버선, 장신구, 머리장식 비용이 추가로 들어갈 수 있어요. 전체 패키지 기준으로 예산을 잡으세요.',
    },
  ],

  results: [
    {
      key: 'practical',
      displayName: '실속 대여형',
      summary: '합리적인 방법으로 아름다운 한복을 입고 싶은 타입이에요. 대여 한복의 높은 퀄리티로 본식 당일만을 위한 최적의 선택을 추천드려요.',
      plannerInterpretation: '대여 한복도 요즘은 정말 퀄리티가 좋아졌어요. 보관 걱정 없이 당일에만 예쁘게 입고 반납하면 되니까 정신없는 결혼 준비 과정에서 오히려 실용적인 선택이 될 수 있어요. 인기 디자인은 시즌 전에 예약이 마감될 수 있으니 미리 예약하는 게 중요해요.',
      recommendDirection: '대여 한복 전문숍에서 시즌에 맞는 신상 라인을 먼저 확인하세요. 대여 시에도 기본 수선(저고리 길이, 치마 길이)이 포함되는지 꼭 확인하는 게 좋아요.',
      keywords: ['합리적', '간편', '대여'],
      styleProfile: [
        { label: '전통미 선호도', value: 40 },
        { label: '실용성 중시', value: 90 },
        { label: '원단 관심도', value: 25 },
        { label: '맞춤형 선호', value: 15 },
        { label: '개성 추구', value: 35 },
      ],
      recommendedCombo: '대여 한복 + 기본 수선 포함 패키지',
      situationalGuides: [
        {
          title: '결혼식 당일에만 한복을 입을 때',
          description: '대여 한복은 보관과 관리 부담이 없어서 당일만 입는 분들께 가장 효율적인 선택이에요. 최신 디자인도 얼마든지 대여할 수 있어요.',
        },
        {
          title: '예산을 다른 항목에 더 투자하고 싶을 때',
          description: '한복 예산을 줄이고 웨딩드레스나 예물에 더 투자하는 전략도 좋아요. 대여 한복으로도 충분히 아름다운 사진을 남길 수 있어요.',
        },
        {
          title: '보관 공간이 마땅치 않을 때',
          description: '한복은 보관이 까다로워요. 대여하면 보관 걱정 없이 당일에만 예쁘게 입고 돌려드리면 되니까 정말 편리해요.',
        },
      ],
    },
    {
      key: 'classic',
      displayName: '클래식 밸런스형',
      summary: '전통미를 살리면서도 무난하고 품격 있는 한복을 원하는 타입이에요. 반맞춤이나 기본 맞춤으로 안정적인 선택을 추천드려요.',
      plannerInterpretation: '클래식한 한복은 10년, 20년 후 사진을 봐도 절대 촌스럽지 않아요. 연지, 분홍, 아이보리 계열의 기본 컬러와 무난한 실루엣이 가장 실패 확률이 낮은 선택이에요. 반맞춤으로 체형에 맞게 수선하면 더 완성도가 올라가요.',
      recommendDirection: '클래식한 컬러와 디자인의 반맞춤 대여나 기본 맞춤을 추천드려요. 저고리 길이와 치마 풍성함이 본인의 체형과 잘 맞는지 여러 번 확인하세요.',
      keywords: ['무난한', '품격', '균형'],
      styleProfile: [
        { label: '전통미 선호도', value: 70 },
        { label: '실용성 중시', value: 60 },
        { label: '원단 관심도', value: 50 },
        { label: '맞춤형 선호', value: 50 },
        { label: '개성 추구', value: 50 },
      ],
      recommendedCombo: '반맞춤 대여 + 클래식 컬러 + 체형 수선',
      situationalGuides: [
        {
          title: '무난하면서도 격식 있는 한복을 원할 때',
          description: '클래식 컬러와 디자인은 어떤 예식장, 어떤 시즌에도 완벽하게 어울려요. 가장 안전한 선택이에요.',
        },
        {
          title: '체형에 맞는 편안함을 느끼고 싶을 때',
          description: '반맞춤은 기본 틀에 체형 보정을 더해주니까 대여보다 착용감이 훨씬 좋아요. 사진에서도 실루엣이 더 예쁘게 나와요.',
        },
        {
          title: '본식과 폐백 모두 한복을 입을 때',
          description: '본식과 폐백 모두 한복을 입으신다면 반맞춤 이상을 추천드려요. 두 가지 용도에 모두 어울리는 디자인을 고를 수 있어요.',
        },
      ],
    },
    {
      key: 'traditional',
      displayName: '전통미 완성형',
      summary: '한복의 전통적인 아름다움과 격식을 중요하게 생각하는 타입이에요. 정통 맞춤 제작과 궁중 스타일로 완성하는 품격 있는 한복을 추천드려요.',
      plannerInterpretation: '전통 한복의 깊은 아름다움은 맞춤 제작에서 가장 빛나요. 내 몸에 딱 맞춘 저고리와 치마의 실루엣, 전통 자수의 정교함은 대여 한복에서는 경험하기 어려운 감동을 선사합니다. 특히 혼주 한복까지 함께 맞추면 가족 모두의 품격이 살아나요.',
      recommendDirection: '전통 궁중 스타일의 맞춤 제작을 추천드려요. 원단은 계절에 맞는 고급스러운 소재를 선택하고, 자수와 디테일에 신경 쓰면 정말 아름다운 한복이 완성돼요.',
      keywords: ['전통', '맞춤', '품격'],
      styleProfile: [
        { label: '전통미 선호도', value: 90 },
        { label: '실용성 중시', value: 30 },
        { label: '원단 관심도', value: 70 },
        { label: '맞춤형 선호', value: 85 },
        { label: '개성 추구', value: 40 },
      ],
      recommendedCombo: '궁중 스타일 맞춤 + 고급 원단 + 전통 자수',
      situationalGuides: [
        {
          title: '가족 모두의 품격을 챙기고 싶을 때',
          description: '혼주 한복까지 함께 맞춤 제작하면 통일감 있고 격식 있는 웨딩이 완성돼요. 세트로 맞추면 가격 협상도 유리해요.',
        },
        {
          title: '평생 소장할 가치 있는 한복을 원할 때',
          description: '맞춤 제작 한복은 내 몸에만 맞는 유일무이한 예술품이에요. 자녀의 돌잔치, 결혼식 등 특별한 날에도 계속 입을 수 있어요.',
        },
        {
          title: '전통 혼례의 의미를 중요하게 생각할 때',
          description: '궁중 스타일 맞춤 한복은 전통 혼례의 깊은 의미를 담아내기에 완벽한 선택이에요. 모든 순간이 더 특별해져요.',
        },
      ],
    },
    {
      key: 'modern',
      displayName: '모던 감각형',
      summary: '한복에 현대적인 감각과 개성을 담고 싶은 타입이에요. 퓨전 스타일과 트렌디한 컬러 배색으로 남다른 한복을 추천드려요.',
      plannerInterpretation: '모던 한복은 전통의 틀 안에서 현대적인 아름다움을 표현하는 예술이에요. 파스텔 톤, 독특한 배색, 현대적인 실루엣으로 젊고 세련된 느낌을 연출할 수 있어요. 특히 하우스 웨딩이나 야외 웨딩에서 그 매력이 극대화돼요.',
      recommendDirection: '파스텔이나 트렌디한 컬러 배색의 퓨전 한복을 추천드려요. 저고리 길이나 소매 디자인에 현대적인 변형을 주면 더 개성 있는 스타일이 완성돼요.',
      keywords: ['모던', '퓨전', '트렌디'],
      styleProfile: [
        { label: '전통미 선호도', value: 30 },
        { label: '실용성 중시', value: 55 },
        { label: '원단 관심도', value: 60 },
        { label: '맞춤형 선호', value: 60 },
        { label: '개성 추구', value: 90 },
      ],
      recommendedCombo: '퓨전 한복 + 트렌디 컬러 배색 + 현대적 디테일',
      situationalGuides: [
        {
          title: '하우스 웨딩이나 야외 웨딩을 계획 중일 때',
          description: '모던 한복은 작은 결혼식, 하우스 웨딩, 야외 웨딩에서 특히 빛나요. 공간과 조화를 이루는 컬러를 선택하면 더욱 아름다워요.',
        },
        {
          title: '전통은 살리되 남다른 느낌을 원할 때',
          description: '퓨전 한복은 전통의 아름다움은 유지하면서도 개성을 표현할 수 있어요. 독특한 배색이나 현대적인 실루엣으로 차별화된 스타일을 완성하세요.',
        },
        {
          title: 'SNS에 남길 특별한 웨딩 사진을 원할 때',
          description: '트렌디한 컬러와 디자인의 한복은 사진에서 정말 돋보여요. 특히 야외 촬영에서 자연광과 어우러질 때 그 아름다움이 배가 돼요.',
        },
      ],
    },
    {
      key: 'luxury',
      displayName: '프리미엄 헤리티지형',
      summary: '한복을 평생의 유산으로 생각하는 타입이에요. 최고급 원단, 장인의 핸드메이드, 정교한 자수로 완성하는 프리미엄 맞춤 한복을 추천드려요.',
      plannerInterpretation: '프리미엄 맞춤 한복은 단순한 의상이 아니라 예술 작품이에요. 수십 년 경력의 장인이 한 땀 한 땀 완성하는 자수, 최고급 원단의 은은한 광택, 내 몸에 완벽하게 맞는 실루엣은 착용하는 순간의 감동이 완전히 달라요. 자녀에게 물려줄 수 있는 진정한 유산이 됩니다.',
      recommendDirection: '최고급 원단(순견, 고급 갑사 등)과 장인의 핸드메이드 자수가 들어간 풀 맞춤을 추천드려요. 맞춤 제작은 최소 8주 이상의 여유를 두고 시작하는 게 좋아요.',
      keywords: ['프리미엄', '장인', '유산'],
      styleProfile: [
        { label: '전통미 선호도', value: 85 },
        { label: '실용성 중시', value: 15 },
        { label: '원단 관심도', value: 95 },
        { label: '맞춤형 선호', value: 95 },
        { label: '개성 추구', value: 60 },
      ],
      recommendedCombo: '최고급 원단 + 장인 핸드메이드 + 정교한 자수 + 풀 맞춤',
      situationalGuides: [
        {
          title: '한복을 예술 작품으로 생각할 때',
          description: '장인의 정교한 자수와 최고급 원단으로 완성된 한복은 착용하는 것만으로도 특별한 경험이에요. 평생 잊지 못할 감동을 선사합니다.',
        },
        {
          title: '자녀에게 물려줄 유산으로 준비할 때',
          description: '프리미엄 맞춤 한복은 시간이 지나도 가치가 변하지 않아요. 자녀의 결혼식에서 다시 입을 수 있는 진정한 헤리티지가 됩니다.',
        },
        {
          title: '원단과 디테일에 타협하고 싶지 않을 때',
          description: '고급 순견, 갑사, 노방 등 최고급 원단은 광택과 촉감이 일반 원단과는 비교할 수 없어요. 자수 하나하나가 예술이에요.',
        },
      ],
    },
  ],

  calculateResult(answers: Record<string, string[]>): string {
    const scores: Record<string, number> = {
      practical: 0,
      classic: 0,
      traditional: 0,
      modern: 0,
      luxury: 0,
    };

    Object.entries(answers).forEach(([questionId, selectedIds]) => {
      const question = hanbokGuide.questions.find((q) => q.id === questionId);
      if (!question) return;

      selectedIds.forEach((optionId) => {
        const option = question.options.find((o) => o.id === optionId);
        if (!option || !option.resultType) return;

        if (scores[option.resultType] !== undefined) {
          scores[option.resultType] += 1;
        }
      });
    });

    let maxType = 'classic';
    let maxScore = 0;
    Object.entries(scores).forEach(([type, score]) => {
      if (score > maxScore) {
        maxScore = score;
        maxType = type;
      }
    });

    return maxType;
  },
  enabled: true,
  headerTitle: '한복 가이드',
  startTitle: '가족의 품격을\n완성하는 색',
  startDescription: '현직 웨딩 플래너 12인이 검증한\n한복 의사결정 기준',
  startCtaText: '한복 기준 찾기',
  hubMainCopy: '가족의 품격을 완성하는 색',
  hubDescription: '신랑신부와 혼주 한복의 용도, 색감, 대여·맞춤 기준을 정리해\n상황에 맞는 한복 선택 방향을 확인해보세요.',
  hubTags: ['전통', '퓨전', '대여', '맞춤'],
};